import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { XMarkIcon, EyeIcon } from '@heroicons/react/24/outline';
import { storyService } from '../services/storyService';
import LoadingSpinner from '../../../components/common/LoadingSpinner';

const formatDateTime = (dateString) => {
  if (!dateString) return null;
  return new Date(dateString).toLocaleString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
};

const StoryViewersModal = ({ story, onClose }) => {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['story-viewers', story?.id],
    queryFn: () => storyService.getViewers(story.id),
    enabled: !!story,
  });

  if (!story) return null;

  return (
    <div className="fixed inset-0 bg-black/30 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl w-full max-w-sm max-h-[80vh] overflow-y-auto">
        <div className="flex justify-between items-center p-4 border-b sticky top-0 bg-white z-10">
          <h2 className="text-lg font-bold text-gray-800 flex items-center gap-2">
            <EyeIcon className="h-5 w-5 text-gray-500" />
            Vues de la story
          </h2>
          <button
            onClick={onClose}
            className="p-1 rounded-full hover:bg-gray-100 transition-colors"
            aria-label="Fermer"
          >
            <XMarkIcon className="h-6 w-6 text-gray-500" />
          </button>
        </div>

        <div className="p-4">
          {isLoading && <LoadingSpinner />}
          {isError && (
            <p className="text-sm text-red-500 py-4 text-center">
              Impossible de charger les vues de cette story.
            </p>
          )}
          {data && (
            <>
              <p className="text-sm text-gray-500 mb-3">
                {data.count} vue{data.count > 1 ? 's' : ''}
              </p>
              {data.count > 0 ? (
                <ul className="divide-y divide-gray-100">
                  {data.viewers.map((viewer, index) => (
                    <li key={index} className="py-2 flex justify-between items-center text-sm">
                      <span className="text-gray-800">{viewer.name}</span>
                      <span className="text-gray-400 text-xs">{formatDateTime(viewer.viewed_at)}</span>
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="text-sm text-gray-400 text-center py-4">Personne n'a encore vu cette story.</p>
              )}
            </>
          )}
        </div>

        <div className="flex justify-end p-4 border-t border-gray-200">
          <button
            onClick={onClose}
            className="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors"
          >
            Fermer
          </button>
        </div>
      </div>
    </div>
  );
};

export default StoryViewersModal;
